import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { BaseComponent } from '../../shared/components/base/base.component';
import { TitleService } from '../../shared/services/title.service';
import { environment } from '../../../environments/environment';
import {
  LEAD_BLITZSHARE,
  LEAD_PHOTOGRAPHY,
  LEAD_REAL_ESTATE,
  LEAD_SOFTWARE_DEVELOPER,
  LEAD_TRUMP_POST_ALERT,
} from '../../shared/constants/strings';
import { UtilService } from '../../shared/util.service';
import { MetadataService } from '../../shared/services/metadata.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatCardModule],
})
export class StartComponent extends BaseComponent implements OnInit {
  imgWidths = [2000, 1500, 1000, 750, 500, 350];
  trumpImageWidths = [1681, 1500, 1200, 750, 500, 350];
  imgPath = environment.storageImgPath;
  trumpFallbackImage = this.imgPath + '/start/trump-post-alert-w1200.webp';

  constructor(
    private metadataService: MetadataService,
    private utilService: UtilService,
    private titleService: TitleService,
  ) {
    super();
  }

  public get LEAD_SOFTWARE_DEVELOPER() {
    return LEAD_SOFTWARE_DEVELOPER;
  }

  public get LEAD_PHOTOGRAPHY() {
    return LEAD_PHOTOGRAPHY;
  }

  public get LEAD_REAL_ESTATE() {
    return LEAD_REAL_ESTATE;
  }

  public get LEAD_BLITZSHARE() {
    return LEAD_BLITZSHARE;
  }

  public get LEAD_TRUMP_POST_ALERT() {
    return LEAD_TRUMP_POST_ALERT;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleService.setRawTitle(environment.defaultTitle);
    this.metadataService.updateTags(
      'Startseite',
      'Digitale Visitenkarte von Alexander Schwartz - Software-Entwickler, Fotograf, Immobilieninvestor, Gründer von Blitzshare.de und TrumpPostAlert.com',
      'aSchwartz, Software entwicklung, Fotografie, Immobilien, Investments, Blitzshare.de, Trump Post Alert',
      undefined,
      environment.applicationRootUrl,
    );
  }

  goToMyServices(): void {
    this.utilService.scrollToId('my-services');
  }
}
